"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
export default function Reach() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.18
  });
  const locations = [{
    id: 1,
    city: "PROTECTION ISLAND · HQ",
    annotation: "— Wildlife Sanctuary",
    address: "Protection Island NWR, WA",
    signoff: "— protect the habitat",
    x: 28,
    y: 42,
    isHQ: true
  }, {
    id: 2,
    city: "DUNGENESS",
    annotation: "— Coastal Refuge",
    address: "Dungeness National Wildlife Refuge",
    signoff: "— preserve the shore",
    x: 49,
    y: 36,
    isHQ: false
  }, {
    id: 3,
    city: "STRAIT",
    annotation: "— Marine Corridor",
    address: "Strait of Juan de Fuca",
    signoff: "— watch the birds",
    x: 78,
    y: 60,
    isHQ: false
  }, {
    id: 4,
    city: "PACIFIC",
    annotation: "— Migratory Path",
    address: "Pacific Flyway Zone",
    signoff: "— keep them safe",
    x: 35,
    y: 78,
    isHQ: false
  }, {
    id: 5,
    city: "ESTUARY",
    annotation: "— Wetland Zone",
    address: "Protected Estuary Basin",
    signoff: "— nature thrives",
    x: 26,
    y: 36,
    isHQ: false
  }];
  const nycX = 28;
  const nycY = 42;
  return <section data-section-id="1711" id="our-service-area" ref={sectionRef} className="bg-background text-foreground relative overflow-hidden py-24 md:py-36" style={{
    backgroundColor: "#EAF4EA",
    color: "#0F3D2E"
  }}>
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.06] mix-blend-multiply" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2'/></filter><rect width='100%25' height='100%25' filter='url(%23n)' opacity='0.6'/></svg>\")"
    }} />

      <div className="container mx-auto max-w-[1320px] px-5 md:px-8 lg:px-14 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div className={`lg:col-span-4 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            {}
            <div className="flex items-start gap-3 mb-6">
              <span className="font-default text-xs uppercase tracking-[0.18em]" style={{
              color: "#228B22"
            }}>
                № 02 / OUR PROTECTED ZONES
              </span>
              <span className="inline-block -mt-2 -rotate-2 text-2xl" style={{
              color: "#0000FF"
            }}>
                № 02
              </span>
            </div>

            {}
            <h2 className="font-default font-normal leading-[1.06] tracking-tight mb-6" style={{
            fontSize: "clamp(2rem, 3.4vw, 3rem)",
            color: "#0F3D2E"
          }}>
              A{" "}
              <span className="relative inline-block">
                <em className="not-italic relative inline-block" style={{
                color: "#0000FF",
                fontWeight: 500,
                transform: "rotate(-2deg)",
                display: "inline-block",
                padding: "0 0.15em"
              }}>
                  vital
                  {}
                  <svg aria-hidden="true" className="absolute inset-0 w-full h-full overflow-visible" viewBox="0 0 100 50" preserveAspectRatio="none">
                    <path d="M 8,30 C 5,12 30,4 55,8 C 85,12 98,28 92,38 C 84,50 50,52 25,46 C 8,42 4,36 10,28" fill="none" stroke="#0000FF" strokeWidth="1.4" strokeLinecap="round" style={{
                    strokeDasharray: 220,
                    strokeDashoffset: isVisible ? 0 : 220,
                    transition: "stroke-dashoffset 900ms ease-out 400ms"
                  }} />
                  </svg>
                </em>
              </span>{" "}
              sanctuary,
              <br />
              wild and free.
            </h2>

            <p className="font-default text-base md:text-[1.0625rem] leading-[1.62] mb-10 max-w-md" style={{
            color: "#0F3D2E"
          }}>
              We focus our advocacy on the critical habitats of Protection Island and Dungeness. Our mission is to inform the public on how to protect our wildlife and sea bird refuges, ensuring these ecosystems remain undisturbed for generations.
            </p>

            {}
            <ul className="space-y-5 mb-10">
              {locations.map((loc, i) => <li data-index={i} key={loc.id} className={`flex items-start gap-4 transition-all duration-500 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}`} style={{
              transitionDelay: `${300 + i * 80}ms`
            }}>
                  {}
                  <span aria-hidden="true" className="mt-2 shrink-0 inline-block" style={{
                width: 12,
                height: 10,
                backgroundColor: "#228B22",
                borderRadius: "4px"
              }} />
                  <div className="flex-1 min-w-0">
                    <div className="font-default text-[0.75rem] uppercase tracking-[0.18em] leading-tight" style={{
                  color: "#228B22"
                }}>
                      {loc.city}
                    </div>
                    <div className="-mt-0.5" style={{
                  color: "#0000FF",
                  fontSize: "1.25rem",
                  transform: "rotate(-2deg)",
                  display: "inline-block",
                  lineHeight: 1.1
                }}>
                      {loc.annotation}
                    </div>
                  </div>
                </li>)}
            </ul>

            {}
            <div className="mt-6">
              <div aria-hidden="true" className="relative inline-flex items-center justify-center shadow-md" style={{
              width: 88,
              height: 88,
              borderRadius: "4px",
              backgroundColor: "#228B22",
              transform: "rotate(-6deg)",
              color: "#F7FBFF"
            }}>
                <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full">
                  <defs>
                    <path id="seal-curve" d="M 50,50 m -36,0 a 36,36 0 1,1 72,0 a 36,36 0 1,1 -72,0" />
                  </defs>
                  <text fontFamily="sans-serif" fontSize="9" fill="#F7FBFF" letterSpacing="2">
                    <textPath href="#seal-curve" startOffset="0">
                      PROTECT · WILDLIFE · REFUGE · ADVOCACY ·
                    </textPath>
                  </text>
                </svg>
                <span style={{
                fontSize: "1.5rem",
                lineHeight: 1
              }}>
                  FOTR
                </span>
              </div>
            </div>
          </div>

          {}
          <div className={`lg:col-span-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: "200ms"
        }}>
            <div className="relative w-full overflow-hidden border" style={{
            aspectRatio: "16 / 11",
            minHeight: 420,
            backgroundColor: "#F7FBFF",
            borderColor: "#228B22",
            borderRadius: "4px"
          }}>
              {}
              <svg viewBox="0 0 1000 700" preserveAspectRatio="xMidYMid slice" className="absolute inset-0 w-full h-full" aria-label="Refuge map">
                {}
                <rect width="1000" height="700" fill="#EAF4EA" />

                {}
                <rect width="1000" height="700" fill="url(#mapGrain)" opacity="0.08" />
                <defs>
                  <pattern id="mapGrain" width="6" height="6" patternUnits="userSpaceOnUse">
                    <circle cx="1" cy="1" r="0.5" fill="#228B22" />
                  </pattern>
                </defs>

                {}
                <path d="M 80,120 Q 60,180 90,240 Q 70,280 110,320 Q 130,360 200,380 Q 280,400 340,360 Q 360,300 330,260 Q 320,200 280,170 Q 260,140 220,130 Q 180,110 140,115 Q 100,108 80,120 Z" fill="#228B22" opacity="0.85" stroke="#0F3D2E" strokeWidth="1.2" />
                <path d="M 280,440 Q 270,500 300,560 Q 320,620 360,640 Q 390,610 380,550 Q 395,490 370,440 Q 340,410 310,420 Q 285,425 280,440 Z" fill="#228B22" opacity="0.85" stroke="#0F3D2E" strokeWidth="1.2" />
                <path d="M 460,180 Q 440,220 470,260 Q 510,280 560,260 Q 600,240 590,200 Q 570,170 530,165 Q 490,165 460,180 Z" fill="#228B22" opacity="0.85" stroke="#0F3D2E" strokeWidth="1.2" />
                <path d="M 500,310 Q 480,380 510,460 Q 540,520 580,510 Q 610,460 600,400 Q 605,340 570,310 Q 535,295 500,310 Z" fill="#228B22" opacity="0.85" stroke="#0F3D2E" strokeWidth="1.2" />
                <path d="M 590,150 Q 620,210 680,230 Q 760,240 820,220 Q 880,200 890,170 Q 870,130 810,125 Q 730,115 670,130 Q 610,135 590,150 Z" fill="#228B22" opacity="0.85" stroke="#0F3D2E" strokeWidth="1.2" />
                <path d="M 760,380 Q 790,400 830,400 Q 860,395 855,420 Q 820,440 780,430 Q 755,420 760,380 Z" fill="#228B22" opacity="0.85" stroke="#0F3D2E" strokeWidth="1.2" />
                <path d="M 800,500 Q 780,540 820,560 Q 870,565 890,540 Q 895,510 860,495 Q 825,490 800,500 Z" fill="#228B22" opacity="0.85" stroke="#0F3D2E" strokeWidth="1.2" />

                {}
                {locations.filter(l => !l.isHQ).map((loc, i) => {
                const x1 = nycX / 100 * 1000;
                const y1 = nycY / 100 * 700;
                const x2 = loc.x / 100 * 1000;
                const y2 = loc.y / 100 * 700;
                const cx = (x1 + x2) / 2;
                const cy = (y1 + y2) / 2 - 80;
                return <path data-index={i} key={loc.id} d={`M ${x1},${y1} Q ${cx},${cy} ${x2},${y2}`} fill="none" stroke="#0000FF" strokeWidth="1.2" strokeLinecap="round" strokeDasharray="4 3" opacity="0.7" style={{
                  strokeDasharray: 800,
                  strokeDashoffset: isVisible ? 0 : 800,
                  transition: `stroke-dashoffset 1200ms ease-out ${600 + i * 150}ms`
                }} />;
              })}
              </svg>

              {}
              {locations.map((loc, i) => <div data-index={i} key={loc.id} className="absolute" style={{
              left: `${loc.x}%`,
              top: `${loc.y}%`,
              transform: "translate(-50%, -50%)"
            }}>
                  <HoverCard openDelay={120} closeDelay={80}>
                    <HoverCardTrigger asChild>
                      <button type="button" aria-label={loc.city} className="relative block focus:outline-none">
                        {loc.isHQ ? <>
                            <span aria-hidden="true" className="absolute inset-0 rounded-lg animate-ping" style={{
                        width: 22,
                        height: 22,
                        left: -11,
                        top: -11,
                        backgroundColor: "#228B22",
                        borderRadius: "9999px",
                        animationDuration: "1.6s"
                      }} />
                            <span aria-hidden="true" className="relative inline-block" style={{
                        width: 16,
                        height: 16,
                        backgroundColor: "#228B22",
                        borderRadius: "4px",
                        boxShadow: "0 0 0 3px #F7FBFF, 0 2px 6px #0F3D2E"
                      }} />
                          </> : <span aria-hidden="true" className="relative inline-block" style={{
                      width: 11,
                      height: 11,
                      backgroundColor: "#228B22",
                      borderRadius: "4px",
                      boxShadow: "0 0 0 2px #F7FBFF, 0 1px 3px #0F3D2E"
                    }} />}

                        <span className="absolute font-default uppercase whitespace-nowrap pointer-events-none" style={{
                      fontSize: "0.6875rem",
                      letterSpacing: "0.18em",
                      color: "#228B22",
                      left: loc.isHQ ? 18 : 14,
                      top: -6
                    }}>
                          {loc.city}
                        </span>
                      </button>
                    </HoverCardTrigger>
                    <HoverCardContent className="w-64 border" align="center" sideOffset={12} style={{
                  backgroundColor: "#F7FBFF",
                  borderColor: "#228B22",
                  color: "#0F3D2E",
                  borderRadius: "4px"
                }}>
                      <div className="font-default text-[0.6875rem] uppercase tracking-[0.18em] mb-2" style={{
                    color: "#228B22"
                  }}>
                        {loc.city}
                      </div>
                      <div className="font-default text-sm leading-relaxed" style={{
                    color: "#0F3D2E"
                  }}>
                        {loc.address}
                      </div>
                      <div className="mt-3 -rotate-2 inline-block" style={{
                    color: "#0000FF",
                    fontSize: "1.25rem",
                    lineHeight: 1
                  }}>
                        {loc.signoff}
                      </div>
                    </HoverCardContent>
                  </HoverCard>
                </div>)}

              {}
              <div aria-hidden="true" className="absolute pointer-events-none" style={{
              left: `${nycX}%`,
              top: `${nycY}%`,
              transform: "translate(-50%, -50%)",
              width: 110,
              height: 110
            }}>
                <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
                  <path d="M 50,12 C 78,10 90,30 88,52 C 86,78 64,90 44,86 C 18,82 8,58 14,38 C 20,20 34,12 50,12 Z" fill="none" stroke="#0F3D2E" strokeWidth="1.4" strokeLinecap="round" style={{
                  strokeDasharray: 280,
                  strokeDashoffset: isVisible ? 0 : 280,
                  transition: "stroke-dashoffset 1100ms ease-out 700ms"
                }} />
                </svg>
              </div>

              {}
              <div aria-hidden="true" className="absolute pointer-events-none" style={{
              left: `${nycX - 14}%`,
              top: `${nycY + 6}%`,
              transform: "rotate(-3deg)"
            }}>
                <span style={{
                color: "#0F3D2E",
                fontSize: "1.5rem",
                lineHeight: 1
              }}>
                  — here
                </span>
                <svg className="absolute" style={{
                left: 42,
                top: -18,
                width: 60,
                height: 40
              }} viewBox="0 0 60 40">
                  <path d="M 4,32 Q 25,8 52,18 L 46,12 M 52,18 L 44,22" fill="none" stroke="#0F3D2E" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" style={{
                  strokeDasharray: 120,
                  strokeDashoffset: isVisible ? 0 : 120,
                  transition: "stroke-dashoffset 900ms ease-out 1000ms"
                }} />
                </svg>
              </div>
            </div>

            {}
            <div className="mt-4 flex items-center justify-between gap-4">
              <span className="font-default text-[0.6875rem] uppercase tracking-[0.18em]" style={{
              color: "#228B22"
            }}>
                FIG. 02 / REFUGE MAP · EST 2024
              </span>
              <span className="font-default text-[0.6875rem] uppercase tracking-[0.18em]" style={{
              color: "#0F3D2E"
            }}>
                48.2167° N · 122.9333° W
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}